import {
  RESET,
  SET_STATUS,
  DONE_SUCCESS,
  DONE_REQUEST,
  DECREASE_MODAL_COUNT,
  SET_MODAL_COUNT_TO_ZERO,
  SET_MODAL_COUNT,
} from '../actionConstants/sequentialModals';

export const resetSequentialModals = () => ({ type: RESET });
export const doneRequestSequentialModal = ({ modalId, delay }) => ({ type: DONE_REQUEST, payload: { modalId, delay } });
export const doneSuccessSequentialModal = ({ modalId }) => ({
  type: DONE_SUCCESS,
  payload: { modalId },
});
export const setStatusSequentialModal = ({ status }) => ({ type: SET_STATUS, payload: { status } });
export const setModalCount = ({ count }) => ({ type: SET_MODAL_COUNT, payload: { count } });
export const decreaseModalCount = () => ({ type: DECREASE_MODAL_COUNT });
export const setModalCountToZero = () => ({ type: SET_MODAL_COUNT_TO_ZERO });
